<script setup>
// import markdownParser from "@nuxt/content/transformers/markdown"

import showdown from "showdown";

let converter = new showdown.Converter();

const props = defineProps(["markdownString","className"]);

const record = ref("");

// watchEffect(async () => {
//   try{
//     await markdownParser.parse("custom.md", props.markdownString).then((md) => record.value = md);
//   }catch(e){
//     // console.log(e)
//   }
// });

const content = computed( () => {
  return converter.makeHtml(props.markdownString)
})

</script>

<template>
  <div class="w-full px-1 prose " :class="[props.className? props.className :'prose-sm']" v-html="content"></div>
</template>